<template>
  <BaseVeeForm :action="submit" class="p-4 sm:p-6">
    <template #default="formProps">
      <div class="space-y-8">
        <BaseFormTextFieldWithValidator
          v-model="nameInput"
          v-bind="nameFieldProps"
          :disabled="formProps.isPending"
          class="max-w-lg"
        />

        <div class="flex gap-5">
          <BaseButton
            type="button"
            ghost
            :disabled="formProps.isPending"
            @click="$emit('prev-step')"
          >
            Prev
          </BaseButton>
          <BaseButton primary :disabled="formProps.isPending"> Create </BaseButton>
        </div>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { accountEmailTemplatesClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    emailTemplateData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    nameInput: {
      get() {
        return this.emailTemplateData?.name || '';
      },
      set(value) {
        this.$emit('email-template-name:update', value);
      },
    },
    nameFieldProps() {
      return {
        validator: {
          name: 'name',
          vid: 'name',
          rules: 'required',
        },
        field: {
          id: 'email_template_name',
          label: 'Name',
        },
      };
    },
  },
  methods: {
    submit() {
      return accountEmailTemplatesClient
        .store(this.accountId, {
          base_email_template_id: this.emailTemplateData.baseEmailTemplate?.id,
          name: this.emailTemplateData.name,
        })
        .then((response) => {
          this.$emit('created', response.data);
          this.$refs.dialog.close();
        });
    },
  },
};
</script>
